function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import Typography from '../typography';
import classnames from 'classnames';
import './style/index';

var IglooStatusBox = function IglooStatusBox(props) {
  var type = props.type,
      children = props.children,
      color = props.color,
      background = props.background,
      className = props.className,
      style = props.style;
  return _jsx("span", {
    className: classnames("iglooform-status-box-".concat(type), 'iglooform-status-box-container', className),
    style: _objectSpread({
      color: color,
      backgroundColor: background
    }, style),
    children: _jsx(Typography, {
      level: "status",
      children: children
    })
  });
};

export default IglooStatusBox;